import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

import { useTranslation } from "react-i18next";

function Button ( { className, main } ) {

    const { link } = useContext(LinkContext);
    
    const { t } = useTranslation();
      
    return(
        <div className={className}>
            <a href={link}>
                <div className="buttm hover:scale-[1.05] transition-all">
                    <p className="roboto text-[14px] uppercase">{t('home.4')}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="22" viewBox="0 0 47 22" fill="none">
                        <rect width="47" height="22" rx="2" fill="#F0FAF9"/>
                        <path d="M35.3536 11.3536C35.5488 11.1583 35.5488 10.8417 35.3536 10.6464L32.1716 7.46447C31.9763 7.2692 31.6597 7.2692 31.4645 7.46447C31.2692 7.65973 31.2692 7.97631 31.4645 8.17157L34.2929 11L31.4645 13.8284C31.2692 14.0237 31.2692 14.3403 31.4645 14.5355C31.6597 14.7308 31.9763 14.7308 32.1716 14.5355L35.3536 11.3536ZM12 11V11.5H35V11V10.5H12V11Z" fill="black"/>
                    </svg>
                </div>
            </a>
        </div>
    );
}

export default Button;